/**
 * KEY-MADE — the shared type library.  DP51.
 *
 * ONE list.  Before this file there were three, and they disagreed:
 * PropertiesPanel.js (15 families), TextFormatToolbar.js (19, four of which
 * never loaded) and MoodBoardCanvas.js (15 with a `style` field).  All three
 * now derive from here.
 *
 * Each entry is [family, role, note].  Role:
 *   n = Names   b = Sentences   f = Figures   d = Display   s = Hand
 */

export const TYPE_LIBRARY = [
  ['Bodoni Moda', 'n', 'High contrast, editorial. In use for names.'],
  ['Playfair Display', 'n', 'Sharp serif, strong at large sizes.'],
  ['Cormorant Garamond', 'n', 'Delicate old-style. Needs size to read.'],
  ['EB Garamond', 'n', 'Classic book serif, warm.'],
  ['Libre Baskerville', 'n', 'Sturdy, wide, very legible.'],
  ['DM Serif Display', 'n', 'Heavy display serif.'],
  ['Crimson Pro', 'n', 'Quiet literary serif.'],
  ['Crimson Text', 'n', 'Legacy. Kept so saved items still render.'],
  ['Spectral', 'n', 'Serif built for screens.'],
  ['Lora', 'n', 'Brushed contrast, friendly.'],
  ['Merriweather', 'n', 'Dense, high x-height.'],
  ['Source Serif 4', 'n', 'Neutral, technical serif.'],
  ['Newsreader', 'n', 'Editorial, tight.'],
  ['Fraunces', 'n', 'Soft wobble, characterful.'],
  ['Instrument Serif', 'n', 'Tall, condensed display.'],
  ['Young Serif', 'n', 'Slab-ish, blocky.'],
  ['Prata', 'n', 'Elegant Didone.'],
  ['Marcellus', 'n', 'Roman capitals, architectural.'],
  ['Cinzel', 'n', 'Inscriptional capitals.'],
  ['Italiana', 'n', 'Very fine, display only.'],
  ['Gilda Display', 'n', 'Light Didone.'],
  ['Petrona', 'n', 'Warm, low contrast.'],
  ['Bitter', 'n', 'Contemporary slab.'],
  ['Georgia', 'n', 'System serif. No download.'],
  ['Times New Roman', 'n', 'System serif. No download.'],
  ['Archivo', 'b', 'Grotesque workhorse. In use for sentences.'],
  ['Inter', 'b', 'Screen-first neutral.'],
  ['Work Sans', 'b', 'Slightly quirky grotesque.'],
  ['DM Sans', 'b', 'Geometric, low key.'],
  ['Source Sans 3', 'b', 'Adobe neutral, very readable.'],
  ['Source Sans Pro', 'b', 'Legacy, superseded by Source Sans 3. Kept for saved items.'],
  ['Open Sans', 'b', 'Humanist, safe.'],
  ['Roboto', 'b', 'Android neutral.'],
  ['Lato', 'b', 'Warm humanist.'],
  ['Nunito Sans', 'b', 'Rounded terminals.'],
  ['Nunito', 'b', 'Legacy. Kept so saved items still render.'],
  ['Manrope', 'b', 'Modern geometric.'],
  ['Karla', 'b', 'Grotesque with odd details.'],
  ['Rubik', 'b', 'Slightly rounded corners.'],
  ['Public Sans', 'b', 'US government neutral.'],
  ['Figtree', 'b', 'Friendly geometric.'],
  ['Outfit', 'b', 'Even geometric.'],
  ['Plus Jakarta Sans', 'b', 'Contemporary, open.'],
  ['Barlow', 'b', 'Slightly condensed grotesque.'],
  ['IBM Plex Sans', 'b', 'Engineered, pairs with Plex Mono.'],
  ['Libre Franklin', 'b', 'Franklin Gothic revival.'],
  ['Mulish', 'b', 'Minimalist sans.'],
  ['Montserrat', 'b', 'Geometric, wide.'],
  ['Poppins', 'b', 'Circular geometric.'],
  ['Raleway', 'b', 'Elegant, thin at low weights.'],
  ['Arial', 'b', 'System sans. No download.'],
  ['System-UI', 'b', 'Whatever the device uses. No download.'],
  ['IBM Plex Mono', 'f', 'Engineered mono. In use for figures.'],
  ['JetBrains Mono', 'f', 'Tall x-height, very clear digits.'],
  ['Space Mono', 'f', 'Quirky, retro.'],
  ['Roboto Mono', 'f', 'Neutral mono.'],
  ['DM Mono', 'f', 'Light, sparse.'],
  ['Source Code Pro', 'f', 'Adobe mono, dependable.'],
  ['Fira Code', 'f', 'Legacy. Kept so saved items still render.'],
  ['Inconsolata', 'f', 'Narrow, fits tight columns.'],
  ['Courier Prime', 'f', 'Typewriter.'],
  ['Courier New', 'f', 'System mono. No download.'],
  ['Azeret Mono', 'f', 'Squarish, distinctive.'],
  ['Martian Mono', 'f', 'Wide, technical.'],
  ['Anton', 'd', 'Heavy condensed. Headlines only.'],
  ['Oswald', 'd', 'Condensed gothic.'],
  ['Bebas Neue', 'd', 'All caps condensed.'],
  ['Archivo Black', 'd', 'Very heavy grotesque.'],
  ['Archivo Narrow', 'd', 'Narrow, still readable.'],
  ['Barlow Condensed', 'd', 'Tall and narrow.'],
  ['Fjalla One', 'd', 'Condensed, sturdy.'],
  ['Syne', 'd', 'Odd widths, contemporary.'],
  ['Caveat', 's', 'Quick handwriting.'],
  ['Kalam', 's', 'Marker pen.'],
  ['Architects Daughter', 's', 'Drafting hand.'],
  ['Shadows Into Light', 's', 'Light casual hand.'],
  ['Dancing Script', 's', 'Flowing script.'],
  ['Parisienne', 's', 'Formal script.'],
  ['Homemade Apple', 's', 'Loose pen script.'],
];

export const ROLE_FALLBACK = {
  n: ', Georgia, serif',
  b: ', system-ui, sans-serif',
  f: ', ui-monospace, monospace',
  d: ', Impact, sans-serif',
  s: ', cursive',
};

export const ROLE_STYLE = {
  n: 'serif', b: 'sans-serif', f: 'monospace',
  d: 'sans-serif', s: 'handwriting',
};

export function familyStack(name) {
  const row = TYPE_LIBRARY.find(f => f[0] === name);
  return "'" + name + "'" + (row ? ROLE_FALLBACK[row[1]] : ', sans-serif');
}
